window.PURELEI = window.PURELEI || {};

window.PURELEI.currentSwatch = null;

window.PURELEI.groupBy = (array, keyFn) =>
  array.reduce((result, item) => {
    const key = keyFn(item);
    if (!result[key]) result[key] = [];
    result[key].push(item);
    return result;
  }, {});

window.PURELEI.onRadioChange = name => event => {
  const radio = event.target;
  const variantImageUrl = radio.getAttribute("data-variant-image");
  const variantUrl = radio.getAttribute("data-variant-url");

  if (variantImageUrl) {
    const mainImg = document.getElementById(`fmd-main-image-${name}`);
    if (mainImg) mainImg.src = variantImageUrl;
  }

  if (variantUrl) {
    const imageLink = document.getElementById(`fmd-product-image-link-${name}`);
    const titleLink = document.getElementById(`fmd-product-title-link-${name}`);
    if (imageLink) imageLink.href = variantUrl;
    if (titleLink) titleLink.href = variantUrl;
  }
};

window.PURELEI.onSyncRadioChange = event => {
  const radio = event.target;
  if (!window.PURELEI.currentSwatch) {
    window.PURELEI.currentSwatch = radio;
    const selectedColor = radio.getAttribute("data-variant-color");
    if (!selectedColor) return;

    const sameColorRadios = document.querySelectorAll(
      `input[type="radio"][data-variant-color="${selectedColor}"]`
    );
    sameColorRadios.forEach(otherRadio => {
      if (!otherRadio.checked) {
        otherRadio.checked = true;
        otherRadio.dispatchEvent(new Event("change"));
      }
    });

    setTimeout(() => {
      window.PURELEI.currentSwatch = false;
    }, 10);
  }
};

window.PURELEI.initSwatches = () => {
  const elements = document.querySelectorAll('input[data-swatch]');
  const radios = window.PURELEI.groupBy(
    Array.from(elements),
    r => r.name.replace("swatch_", "")
  );

  for (const [name, group] of Object.entries(radios)) {
    group.forEach(radio => {
      radio.addEventListener("change", window.PURELEI.onRadioChange(name));
    });
  }

  elements.forEach(radio => {
    radio.addEventListener("change", window.PURELEI.onSyncRadioChange);
  });
};

document.addEventListener("DOMContentLoaded", window.PURELEI.initSwatches);
